import React from 'react';
import TopicSection from './TopicSection';
import TopicItem from './TopicItem';
import { Wrapper, MainTitle, MainTitleContainer } from './TopicSummary.styles';
import Clipboard from '../../images/icons/Clipboard.svg';

const TopicSummary = ({ topicSummary, onViewPhotos, hasPhotosInGallery }) => {
  if (!topicSummary) {
    return null;
  }

  const {
    cautelar,
    pintura,
    pneus,
    motorCambio,
    luzAdvertencia,
    opcionais,
  } = topicSummary;

  const getMotorCambioColumns = () => {
    const good = motorCambio.filter(item => !item.needsAttention);
    const bad = motorCambio.filter(item => item.needsAttention);
    return { good, bad };
  };

  const motorCambioColumns = motorCambio ? getMotorCambioColumns() : null;

  const getAllPhotos = (items) => items.reduce((acc, item) => [...acc, ...(item.photos || [])], []);

  return (
    <Wrapper>
      <MainTitleContainer>
      <img src={Clipboard} />
      <MainTitle>
      
        Resumo do carro
      </MainTitle>
      </MainTitleContainer>

      {cautelar && (
        <TopicSection
          title="Cautelar"
          items={[cautelar]}
          photos={cautelar.photos}
          onViewPhotos={onViewPhotos}
          hasPhotosInGallery={hasPhotosInGallery}
        />
      )}

      {pintura && (
        <TopicSection
          title="Pintura"
          items={pintura}
          photos={getAllPhotos(pintura)}
          onViewPhotos={onViewPhotos}
          hasPhotosInGallery={hasPhotosInGallery}
        />
      )}

      {pneus && (
        <TopicSection
          title="Pneus"
          items={pneus}
          photos={getAllPhotos(pneus)}
          onViewPhotos={onViewPhotos}
          hasPhotosInGallery={hasPhotosInGallery}
        />
      )}

      {motorCambio && motorCambioColumns && (
        <TopicSection
          title="Motor e Câmbio"
          photos={getAllPhotos(motorCambio)}
          twoColumns
          firstColumnItems={motorCambioColumns.good}
          secondColumnItems={motorCambioColumns.bad}
          onViewPhotos={onViewPhotos}
          hasPhotosInGallery={hasPhotosInGallery}
        />
      )}

      {luzAdvertencia && (
         <TopicSection
          title="Luz de advertência"
          items={[luzAdvertencia]}
          photos={luzAdvertencia.photos}
          onViewPhotos={onViewPhotos}
          hasPhotosInGallery={hasPhotosInGallery}
        />
      )}

      {opcionais && opcionais.map(opcional => (
        <TopicSection
          key={opcional.type}
          title={`Opcionais de ${opcional.type}`}
          items={opcional.items}
          photos={getAllPhotos(opcional.items)}
          twoColumns
          onViewPhotos={onViewPhotos}
          hasPhotosInGallery={opcional.type === 'conforto' ? hasPhotosInGallery : null}
        />
      ))}
    </Wrapper>
  );
};

export default TopicSummary; 